module.exports = __webpack_public_path__ + "static/media/PaymentRecieptScreen.3ea89a97.png";